var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fe:drop-down"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feDropDown0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feDropDown1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "feDropDown2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8.5L12 16.5L19 8.5H5Z",
    fill: "#242424"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.ffe4a5ef62bd704a4d83799df6c4bc18.svg";
export { ForwardRef as ReactComponent };